export const getComponentSuggestions = ()=>[];
